import { motion } from "framer-motion";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LucideIcon, ArrowRight } from "lucide-react";
import { useLocation } from "wouter";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: LucideIcon;
  delay?: number;
  href?: string;
}

export default function ServiceCard({ title, description, icon: Icon, delay = 0, href }: ServiceCardProps) {
  const [_, navigate] = useLocation();

  const handleClick = () => {
    if (href) {
      navigate(href);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true }}
      className={href ? "cursor-pointer" : ""}
      onClick={handleClick}
    >
      <Card className="h-full overflow-hidden relative group border-0 bg-white shadow-md hover:shadow-xl transition-all duration-300">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        <CardHeader className="pb-2">
          <div className="w-14 h-14 rounded-full bg-gradient-to-br from-primary/90 to-primary/70 flex items-center justify-center mb-4 shadow-md transform group-hover:scale-110 transition-transform duration-300">
            <Icon className="w-7 h-7 text-white" />
          </div>
          <CardTitle className="font-heading text-xl group-hover:text-primary transition-colors duration-300">{title}</CardTitle>
        </CardHeader>
        
        <CardContent className="pb-6">
          <p className="text-muted-foreground">{description}</p>
          
          {href && (
            <div className="mt-4 flex items-center font-medium text-primary opacity-0 transform translate-x-[-10px] group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300">
              <span>Learn more</span>
              <ArrowRight className="ml-2 h-4 w-4" />
            </div>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
